import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import RegisterChargerCheckbox from '../../pages/RegisterChargerCheckbox';
import { WeekConfiguration, generatePeakObj } from '../common/utils/peak-off-peak-field';

interface PeakSelectionPickerProps {
  peakSelection: WeekConfiguration;
  onChange: (peak: any) => void;
  editChargerStatus: boolean;
  error?: boolean;
}

const PeakSelectionPicker: React.FC<PeakSelectionPickerProps> = ({ peakSelection, onChange, editChargerStatus, error }) => {
    return(
        <View style={styles.wrapper}>
            <Text style={styles.label}>Peak Hours</Text>
            <RegisterChargerCheckbox
                generatePeakObjCheckbox={peakSelection}
                setPeakSelection={onChange}
                selectionErrors={(err: boolean) => {}}
                checkboxSelected={{ updatedDay: [''], startEndTime: [{}] }}
                editChargerStatus={editChargerStatus}
            />
            {error && <Text style={styles.error}>Please select valid peak hours</Text>}
        </View>
    );
}

const styles = StyleSheet.create({
  wrapper: { marginBottom: 16 },
  label: { color: '#fff', marginBottom: 8, fontWeight: '600' },
  error: { color: 'red', marginTop: 4 },
});

export default PeakSelectionPicker;